// @flow

export const GET_OPENING_HOURS: 'listo/openinghours/GET_OPENING_HOURS' = 'listo/openinghours/GET_OPENING_HOURS';
export const GET_OPENING_HOURS_SUCCESS: 'listo/openinghours/GET_OPENING_HOURS_SUCCESS' = 'listo/openinghours/GET_OPENING_HOURS_SUCCESS';
export const GET_OPENING_HOURS_FAILED: 'listo/openinghours/GET_OPENING_HOURS_FAILED' = 'listo/openinghours/GET_OPENING_HOURS_FAILED';

export default null;
